import * as Yup from "yup";
import { validationsLocale } from "./ValidationsLocale";
import { __ } from "@wordpress/i18n";
import { helpers } from "../../../helpers/forms/helpers";

Yup.setLocale(validationsLocale);

export const validations: Record<string, Yup.ObjectSchema<any>> = {
    property_valuation_proptech: Yup.object().shape({
        address: Yup.string().required(__("O endereço é obrigatório", "dfs-simulators")),
        assetType: Yup.string()
            .oneOf(["apartment", "house"], __("Tipo de imóvel inválido", "dfs-simulators"))
            .required(__("O tipo de imóvel é obrigatório", "dfs-simulators")),
        condition: Yup.string()
            .oneOf(
                ["new", "used", "renovated", "inConstruction", "forRecovery", "ruin"],
                __("Condição inválida", "dfs-simulators")
            )
            .required(__("A condição do imóvel é obrigatória", "dfs-simulators")),
        grossArea: Yup.number()
            .typeError(__("Área bruta deve ser um número", "dfs-simulators"))
            .positive(__("Área bruta deve ser um número positivo", "dfs-simulators"))
            .required(__("Área bruta é obrigatória", "dfs-simulators")),
        usefullArea: Yup.number()
            .typeError(__("Área útil deve ser um número", "dfs-simulators"))
            .positive(__("Área útil deve ser um número positivo", "dfs-simulators"))
            .max(999999, __("Área útil deve ser no máximo 999999", "dfs-simulators"))
            .required(__("Área útil é obrigatória", "dfs-simulators")),
        terrainArea: Yup.number()
            .typeError(__("Área de terreno deve ser um número", "dfs-simulators"))
            .min(0, __("Área de terreno não pode ser negativa", "dfs-simulators"))
            .nullable()
            .transform((value, originalValue) => {
                return originalValue === "" ? null : value;
            })
            .when("assetType", {
                is: "house",
                then: (schema) => schema.required(__("Área de terreno é obrigatória", "dfs-simulators")),
                otherwise: (schema) => schema.notRequired(),
            }),
        constructionYear: Yup.string()
            .oneOf(
                helpers.validateGeneratedYears(),
                __("Ano de contrução inválido", "dfs-simulators")
            )
            .required(__("O ano de contrução é obrigatório", "dfs-simulators")),
        numberOfRooms: Yup.number()
            .oneOf(
                [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                __("Número de quartos inválido", "dfs-simulators")
            )
            .required(__("Número de quartos é obrigatório", "dfs-simulators")),
        // Optional: add latitude & longitude validations if needed
        latitude: Yup.number()
            .typeError(__("Latitude inválida", "dfs-simulators"))
            .required(__("Latitude é obrigatória", "dfs-simulators")),
        longitude: Yup.number()
            .typeError(__("Longitude inválida", "dfs-simulators"))
            .required(__("Longitude é obrigatória", "dfs-simulators")),
        property_intention: Yup.string()
            .oneOf(
                [
                  "Estou a pensar vender este imóvel",
                  "Estou a pensar comprar este imóvel",
                  "Quero apenas avaliar o meu património",
                ],
                __("Escolha inválida", "dfs-simulators")
            )
            .required(__("O que pretende fazer é obrigatório", "dfs-simulators")),
        timing_plan: Yup.string()
            .oneOf(
                [
                  "Nos próximos 3 meses",
                  "Nos próximos 6 meses",
                  "Nos próximos 12 meses",
                  "Não Aplicável",
                ],
                __("Escolha inválida", "dfs-simulators")
            )
            .required(__("Quando pensa fazê-lo é obrigatório", "dfs-simulators")),
    }),
};
